var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show chart",
    clipPath: "url(#clip0_769_61558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4 35.56L19 24.96L25.5 31.46C26.32 32.28 27.64 32.24 28.4 31.38L42.74 15.24C43.44 14.46 43.4 13.26 42.66 12.5C41.86 11.7 40.52 11.72 39.76 12.58L26.98 26.94L20.4 20.36C19.62 19.58 18.36 19.58 17.58 20.36L5.4 32.56C4.62 33.34 4.62 34.6 5.4 35.38L5.58 35.56C6.36 36.34 7.64 36.34 8.4 35.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 33C40.9338 33 42.5 31.4338 42.5 29.5C42.5 27.5662 40.9338 26 39 26C37.0662 26 35.5 27.5662 35.5 29.5C35.5 31.4338 37.0662 33 39 33ZM39 34.75C36.6637 34.75 32 35.9225 32 38.25V39.125C32 39.6063 32.3937 40 32.875 40H45.125C45.6063 40 46 39.6063 46 39.125V38.25C46 35.9225 41.3363 34.75 39 34.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 5C8.90909 5 5.41545 7.54455 4 11.1364C5.41545 14.7282 8.90909 17.2727 13 17.2727C17.0909 17.2727 20.5845 14.7282 22 11.1364C20.5845 7.54455 17.0909 5 13 5ZM13 15.2273C10.7418 15.2273 8.90909 13.3945 8.90909 11.1364C8.90909 8.87818 10.7418 7.04545 13 7.04545C15.2582 7.04545 17.0909 8.87818 17.0909 11.1364C17.0909 13.3945 15.2582 15.2273 13 15.2273ZM13 8.68182C11.6418 8.68182 10.5455 9.77818 10.5455 11.1364C10.5455 12.4945 11.6418 13.5909 13 13.5909C14.3582 13.5909 15.4545 12.4945 15.4545 11.1364C15.4545 9.77818 14.3582 8.68182 13 8.68182Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_61558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.b4a0867e13208f9abdcc830867e70304.svg";
export { ForwardRef as ReactComponent };